import { MapHlp } from 'src/lib/fliko/helpers/map.helper';
import { DefectData } from 'src/lib/fliko/models/defects/defect.data';
import { DefectType } from 'src/lib/fliko/models/defects/defect-settings.data';
import { LocalizationHelper } from 'src/app/shared/helpers/localization.helper';
import { LocalizationService } from 'src/app/shared/services/localization.service';

/**
 * Translates defect types to current language.
 * If translation for current language is missing first available language will be chosen.
 * If translation don't exist at all id of type will be returned
 */
export class DefectTypeTranslator {
  private readonly locHelper;
  private readonly typesMap;

  constructor(types: DefectType[], ls: LocalizationService) {
    this.locHelper = new LocalizationHelper(ls);
    this.typesMap = MapHlp.idMap(types);
  }

  public fromType(type: DefectType): string {
    return this.locHelper.defectTypeLabel(type);
  }

  public fromId(typeId: string): string {
    const type = this.typesMap.get(typeId);
    return type ? this.locHelper.defectTypeLabel(type) : typeId;
  }

  public fromDefect(defect: DefectData): string {
    const type = this.typesMap.get(defect.typeId);
    return type ? this.locHelper.defectTypeLabel(type) : defect.typeId;
  }
}
